module.exports = __webpack_public_path__ + "static/custom-device-826b9315f13f3bdbae4de3f7302787c5.png";